import React from "react";
import HeaderPreview from "../../../GeneratePdf/HeaderPreview";
import FooterPreview from "../../../GeneratePdf/FooterPreview";
import fourQuadrant from "../../../../Assets/Images/Four-Quadrant.png";
import lead from "../../../../Assets/Images/lead.png";
import grow from "../../../../Assets/Images/Conditional2.png"
import self from "../../../../Assets/Images/selfhome.png";
import selfIcon from "../../../../Assets/Images/leader-self.png";
import Icons from "../../../../Assets/Images/leader360.png";
import teamIcon from "../../../../Assets/Images/team.png";


const styles = {
  pageWrapper: { backgroundColor: "#FFFFFF" },
  section: { display: "flex", flexDirection: "column", alignItems: "flex-start", padding: "0px", gap: "16px", width: "468px", height: "593px", position: "absolute", left: "72px", top: "104px" },
  titleContainer: { display: "flex", flexDirection: "column", alignItems: "flex-start", gap: "8px" },
  title: { color: "#00577D", fontFamily: "Helvetica", fontStyle: "normal", fontWeight: 700, fontSize: "14px", lineHeight: "18px", marginTop: 0, marginBottom: 0 },
  introText: { color: "#000000", fontFamily: "Helvetica", fontStyle: "normal", fontWeight: 700, fontSize: "10px", lineHeight: "14px", marginTop: 0, marginBottom: 0 },
  dimensionContainer: { display: "flex", flexDirection: "row", alignItems: "flex-start", gap: "14px" },
  quadrantGraphic: { width: "102px", height: "102px", flexShrink: 0, display: "grid", gridTemplateColumns: "1fr 1fr", gridTemplateRows: "1fr 1fr" },
  quadrantCell: { display: "flex", alignItems: "center", justifyContent: "center", fontSize: "8px", fontFamily: "Helvetica, sans-serif", fontWeight: "700", color: "#FFFFFF", textTransform: "uppercase", padding: "4px", textAlign: "center" },
  dimensionContent: { display: "flex", flexDirection: "column", alignItems: "flex-start", padding: "0px", gap: "4px", width: "380px" },
  dimensionTitle: { color: "#00577D", fontFamily: "Helvetica", fontStyle: "normal", fontSize: "10px", fontWeight: 700, lineHeight: "14px", marginTop: 0, marginBottom: 0, width: "380px", height: "14px" },
  dimensionText: { color: "#000000", fontFamily: "Helvetica", fontStyle: "normal", fontSize: "10px", fontWeight: 400, lineHeight: "14px", marginTop: 0, marginBottom: 0, width: "380px" },
  assessmentOptionsContainer: { display: "flex", flexDirection: "column", alignItems: "flex-start", padding: "0px", gap: "12px", width: "468px", height: "135px" },
  assessmentOptionsTitle: { color: "#00577D", fontFamily: "Helvetica", fontStyle: "normal", fontWeight: 700, fontSize: "14px", lineHeight: "18px", marginTop: 0, marginBottom: 0, width: "468px", height: "18px" },
  optionsContainer: { display: "flex", flexDirection: "row", alignItems: "center", padding: "0px", gap: "12px", width: "468px", height: "105px" },
  optionCard: { display: "flex", flexDirection: "column", alignItems: "flex-start", padding: "0px", height: "105px" },
  optionImageContainer: { display: "flex", flexDirection: "column", alignItems: "flex-start", padding: "0px", gap: "8px", height: "77px" },
  optionTitle: { color: "#00577D", fontFamily: "Helvetica", fontStyle: "normal", fontSize: "14px", fontWeight: 700, lineHeight: "18px", marginTop: 0, marginBottom: 0, height: "18px" },
  optionBottomContainer: { display: "flex", flexDirection: "column", alignItems: "flex-start", padding: "0px", gap: "5px", height: "24px" },
  optionUnderline: { },
  optionDescription: { color: "#00577D", fontFamily: "Helvetica", fontStyle: "normal", fontSize: "10px", fontWeight: 400, lineHeight: "14px", marginTop: 0, marginBottom: 0, height: "14px" },
  mindsetGraphic: { width: "102px", height: "102px", flexShrink: 0, display: "flex", flexDirection: "row" },
  mindsetCell: { flex: 1, display: "flex", alignItems: "center", justifyContent: "center" },
  arrowOverlay: { position: "relative" },
  arrowSvg: { position: "absolute", top: "50%",left: "50%",transform: "translate(-50%, -50%)", width: "60px", height: "60px",
  },
};

export default function QuadrentFlowMeasure({ pageNumber, reportType, apiData }) {
  const imageStyle = {
    width: "74px",
    height: "74px",
    objectFit: "contain",
  };

  const iconStyle = {
    width: "62px",
    height: "51px",
    objectFit: "contain",
  };

  const dimensions = [
    {
      id: 1,
      title: "HOME",
      image: self,
      text: "Identifies your <strong>Starter Quadrant</strong>: Heart, Soul, Mind, or Strength. This is your natural starting point for action, decision-making, and presence, shaped by a mix of wiring, environment, and life experience."
    },
    {
      id: 2,
      title: "FLOW",
      image: fourQuadrant,
      text: "Assesses your <strong>Flow Type™</strong>, the order in which you move through the remaining quadrants. Your first shift after your Starter is often the strongest and reveals how you instinctively respond. From this sequence, one of 24 unique flow patterns emerges and shows how you adapt and lead in real time. Your least-used quadrant highlights an overlooked or underdeveloped capability."
    },
    {
      id: 3,
      title: "LEAD",
      image: lead,
      text: "Maps your <strong>Leadership Style</strong> (Strategic, Performance, Collaborative, or Visionary) using a validated quadrant-based framework. It also provides a GAP analysis between your Starter Quadrant and your current leadership expression, which highlights alignment or tension in how you show up."
    },
    {
      id: 4,
      title: "GROW",
      image: grow,
      text: "Evaluates your <strong>Mindset</strong> across a spectrum from more fixed to more growth oriented. This reveals how open you are to change, challenge, feedback, and the ongoing work of growth."
    }
  ];

  const assessmentOptions = [
    {
      title: "LEADER SELF",
      description: "SEE YOURSELF",
      image: selfIcon
    },
    {
      title: "LEADER 360",
      description: "HOW OTHERS EXPERIENCE YOU",
      image: Icons
    },
    {
      title: "TEAM TOGETHER",
      description: "UNLOCK TEAM DYNAMICS",
      image: teamIcon
    }
  ];

  return (
    <div className="overview-section" style={styles.pageWrapper}>
      <HeaderPreview apiData={apiData} />
      <div className="overview-section" style={styles.section}>
        <div style={styles.titleContainer}>
          <h2 style={styles.title}>
            WHAT DOES QUADRANT FLOW™ MEASURE?
          </h2>
          <p style={styles.introText}>
            Built on the Human Operating System™ (HOS) framework, the Quadrant Flow™ assessment uses 82 questions and a 4-point scale to measure the integrative power of your life and leadership across four key dimensions:
          </p>
        </div>

        {dimensions.map((dimension) => (
          <div
            key={dimension.id}
            style={{ ...styles.dimensionContainer, ...(dimension.id === 2 ? { alignItems: "center" } : {}) }}
          >
            <img src={dimension.image} alt={dimension.title} style={imageStyle} />
            <div style={styles.dimensionContent}>
              <h3 style={styles.dimensionTitle}>{dimension.id}. {dimension.title}</h3>
              <p style={styles.dimensionText} dangerouslySetInnerHTML={{ __html: dimension.text }} />
            </div>
          </div>
        ))}

        <div style={styles.assessmentOptionsContainer}>
          <h2 style={styles.assessmentOptionsTitle}>ASSESSMENT OPTIONS</h2>
          <div style={styles.optionsContainer}>
            {assessmentOptions.map((option, index) => (
              <div key={index} style={styles.optionCard}>
                <div style={styles.optionImageContainer}>
                  <img src={option.image} alt={option.title} style={iconStyle} />
                  <h4 style={styles.optionTitle}>{option.title}</h4>
                </div>
                <div style={styles.optionBottomContainer}>
                  <div style={{...styles.optionUnderline, width: index === 0 ? "136px" : index === 1 ? "172px" : "136px"}}></div>
                  <p style={{...styles.optionDescription, width: index === 0 ? "136px" : index === 1 ? "172px" : "136px"}}>{option.description}</p>
                  <div style={{...styles.optionUnderline, width: index === 0 ? "136px" : index === 1 ? "172px" : "136px"}}></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <FooterPreview reportType={reportType} pageNumber={pageNumber} />
    </div>
  );
}
